import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/ApplicationStore';
import { api } from '../../api/client';

const WebConfig = ({ setWebConfig }) => {
    useEffect(() => {
        const loadData = async () => {
            try {
                const configData = await api('/configuration');
                setWebConfig(configData.data);
                window.__tpc_env = configData.data.ChatBot_insyncEnv;
            } catch (error) {
                console.log(error);
                return;
            }
        };

        loadData();
    }, [setWebConfig]);

    return null;
};

export default connect(
    (state) => state.app,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(WebConfig);
